import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Badge } from "../components/ui/badge";
import { Heart, Video, Loader2 } from 'lucide-react';
import VideoRoom from "../components/VideoRoom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function VideoVisitPage() {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role') || 'family';
  const [visit, setVisit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ended, setEnded] = useState(false);

  useEffect(() => {
    if (code) {
      fetch(`${API}/api/wave4/video-visit/${code}`)
        .then(r => r.ok ? r.json() : null)
        .then(setVisit)
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [code]);

  if (loading) {
    return (
      <div className="min-h-screen bg-sand-100 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-sage-400" />
      </div>
    );
  }

  if (!visit) {
    return (
      <div className="min-h-screen bg-sand-100 flex items-center justify-center p-4">
        <div className="text-center">
          <Video className="w-12 h-12 mx-auto mb-3 text-sand-300" />
          <h1 className="text-xl font-heading font-bold text-[#2C3D30] mb-1">Visit Not Found</h1>
          <p className="text-sm text-[#5C6A5F]">This video visit link may have expired or is invalid.</p>
        </div>
      </div>
    );
  }

  if (ended) {
    return (
      <div className="min-h-screen bg-sand-100 flex items-center justify-center p-4" data-testid="video-visit-ended">
        <div className="text-center">
          <Heart className="w-12 h-12 mx-auto mb-3 text-sage-400" />
          <h1 className="text-xl font-heading font-bold text-[#2C3D30] mb-1">Visit Complete</h1>
          <p className="text-sm text-[#5C6A5F]">Thank you for connecting with the Goodwin Cares team.</p>
          <Badge className="mt-3 bg-sage-50 text-sage-400 rounded-full">You may close this window</Badge>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex flex-col" data-testid="video-visit-page">
      <div className="bg-[#1a1a1a] border-b border-white/10 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Heart className="w-5 h-5 text-sage-400" />
          <span className="text-white font-heading font-medium text-sm">Goodwin Cares</span>
        </div>
        <div className="flex items-center gap-2">
          <Badge className="bg-white/10 text-white/80 rounded-full text-xs">{visit.patient_name}</Badge>
          <Badge className="bg-sage-400/20 text-sage-400 rounded-full text-xs capitalize">{role}</Badge>
        </div>
      </div>
      <div className="flex-1 p-4 max-w-4xl mx-auto w-full">
        <VideoRoom
          visitCode={code}
          patientName={visit.patient_name}
          role={role}
          onEnd={() => setEnded(true)}
        />
      </div>
    </div>
  );
}
